module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "ssg-poi-active-white-filled.59cb0acc.svg";